import _ from 'lodash';
import { createSelector } from 'reselect';

const _scopedState = state => _.get(state, 'entities.experienceInsights', {});
const isInitialLoad = state => _scopedState(state).isInitialLoad;

const experienceInsightsById = (state, experienceId) => _scopedState(state).byId[experienceId];

const experienceEntries = createSelector([experienceInsightsById], insights => _.get(insights, 'goal', 0));

export default {
  experienceInsightsById,
  experienceEntries,
  isInitialLoad,
};
